{
  "manualSupplierNumber": {
    "sectionTitle": "Eiendom som krever manuell behandling av leverandørnummer",
    "sectionDescription": "Eiendommene mangler leverandørnummer, koble opp mot ett organisasjonsnummer manuelt",
    "manualHandlingBadge": "Manuell behandling",
    "navigateButton": "Hent eller opprett leverandørnummer",
    "table": {
      "eiendom": "Eiendom",
      "supplierNumber": "Leverandørnummer",
      "hovednummer": "Hovednummer",
      "municipalityName": "Kommune",
      "area": "Areal"
    },
    "dialog": {
      "title": "Koble leverandørnummer manuelt",
      "addExistingInstruction": "Legg til et eksisterende leverandørnummer",
      "enterForProperty": "Skriv inn leverandørnummeret for {{propertyId}}",
      "connectButton": "Koble leverandørnummer",
      "loadingText": "Henter info fra Skogdata...",
      "successTitle": "Kobling av leverandørnummer var velykket",
      "successMessageLinked": "Leverandørnummer {{supplierNumber}} er lagt til på:",
      "invalidLengthError": "Leverandørnummer må være 5-siffer",
      "saveError": "Kunne ikke lagre leverandørnummer. Vennligst prøv igjen.",
      "supplierNotFoundError": "Fant ikke leverandørnummeret",
      "supplierWrongMunicipalityError": "Leverandørnummeret tilhører en annen kommune"
    }
  },
  "propertyDetails": {
    "editProtectedArea": {
      "pageTitle": "Endre vernet areal"
    }
  },
  "propertyDocumentation": {
    "sectionTitle": "Eiendom som krever dokumentasjon",
    "sectionDescription": "Denne eiendommen ser ut til å være registrert på en annen skogeier enn {{forestOwnerName}}.",
    "uploadButton": "Last opp dokumentasjon",
    "dialogTitle": "Last opp dokumentasjon",
    "confirmButton": "Bekreft og legg til eiendom",
    "documentTypeLabel": "Velg dokumentasjonstype",
    "descriptionLabel": "Beskrivelse",
    "descriptionDescription": "Legg til en valgfri beskrivelse av dokumentet",
    "propertySubtitle": "Eiendom {{propertyNumber}}",
    "table": {
      "eiendom": "Eiendom",
      "leverandorNummer": "Leverandørnummer",
      "municipalityName": "Kommune",
      "potentialHovednummer": "Potensiell hovednummer",
      "area": "Areal"
    },
    "deleteDocument": {
      "title": "Er du sikker på at du vil slette denne filen?",
      "description": "Denne handlingen kan ikke angres. Dokumentet vil bli permanent fjernet."
    },
    "removeProperty": {
      "actionLabel": "Fjern eiendom",
      "title": "Er du sikker på at du vil fjerne registeringen av eiendommen?",
      "cancelLabel": "Avbryt"
    },
    "verifyWithoutDocumentation": {
      "actionLabel": "Verifiser uten dokumentasjon",
      "dialogTitle": "Verifiser uten dokumentasjon",
      "ownershipTypeLabel": "Velg rettighetstype",
      "ownershipTypeRequired": "Rettighetstype må velges",
      "confirmButton": "Verifiser eiendom"
    },
    "undocumentedVerificationDialog": {
      "title": "Eiendommen er verifisert uten dokumentasjon",
      "subtitle": "Velg om du vil laste opp dokumentasjon eller endre selve rettigheten",
      "uploadOption": "Last opp dokumentasjon",
      "uploadDescription": "Legg til et dokument som bekrefter rettigheten",
      "changeTypeOption": "Endre udokumentert rettighetstype",
      "changeTypeDescription": "Juster om rettigheten er bruksrett eller driftsrett",
      "nextButton": "Neste"
    },
    "documentTypeRequired": "Dokumentasjonstype må velges først",
    "supplierNumberError": "Kunne ikke opprette leverandørnummer for skogeier. Prøv igjen.",
    "documentType": {
      "ownership": "Eierskap",
      "exclusiveUsageRights": "Eksklusiv bruksrett",
      "usageRights": "Bruksrett"
    },
    "undocumentedDocumentType": {
      "usageRights": "Bruksrett",
      "exclusiveUsageRights": "Driftsrett"
    }
  },
  "propertyOverview": {
    "productiveArea": "Produktivt areal",
    "protectedArea": "Vernet areal",
    "otherArea": "Annet areal",
    "areaDistributionTitle": "Arealfordeling",
    "areaDistributionDescription": "Oversikt over skogeiers areal",
    "totalAreaLabel": "Totalareal",
    "productiveAreaLabel": "Produktivt areal",
    "protectedAreaLabel": "Vernet areal",
    "distributedOn": "Fordelt på",
    "properties": "eiendommer",
    "mainNumber": "Hovednummer",
    "propertiesTitle": "Eiendommer",
    "propertiesDescription": "Oversikt over eiendommer til skogeier",
    "noPropertiesTitle": "Det finnes ingen eiendommer som er registrert på denne skogeieren.",
    "noPropertiesDescription": "Trykk på \"Legg til ny eiendom\" for å starte prosessen",
    "addNewProperty": "Legg til ny eiendom",
    "archivedPropertiesTitle": "Arkiverte eiendommer",
    "archivedPropertiesDescription": "Eiendommer som tidligere var registrert på skogeieren, men som har blitt solgt eller deaktivert",
    "numberOfSharesTitle": "Antall andeler",
    "numberOfSharesDescription": "Distrubusjon av andeler utover eiendommer",
    "shares": "andeler",
    "notShareholder": "Ikke andelseier",
    "registerShareholder": "Registrer nytt andelseierskap"
  },
  "sameieDocumentation": {
    "sectionTitle": "Sameie som krever dokumentasjon",
    "sectionDescription": "Følgende eiendommer er registrert som sameie og krever dokumentasjon"
  }
}
